import  request  from '../../Interceptor/request.js'

//根据单号查询具体内容
export function waterVolume(data) {
    return request({
        url: '/order',
        method: 'post',
        data:data
    })
}

//用量记录查询
export function content(data){
    return request({
        url: '/paymentInfo/list',
        method: 'get',
        params:data
    })
}


//具体查询
export function seriou(data){
    return request({
        url: '/waterBill/surplusAmount?devId='+data,
        method: 'get'
    })
}

